angular.module('components.caOpenToBuyGrid', [])
    .component('caOpenToBuyGrid', {
        templateUrl: 'main/order/purchaseorder/components/opentobuygrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            purchaseOrder: '<',
            disabled: '<',
            orderChangeCount: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, BudgetsApiService, ToasterService, $rootScope) {
    var vm = this;

    var otbGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.companyBudgets = [];
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();

    vm.captureOtbGrid = captureOtbGrid;

    function onInit() {
        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            recalculateBudgetData();
        });

        $scope.$watch(function () { return vm.purchaseOrder.company.id; }, function () {
            if (vm.purchaseOrder.company && vm.purchaseOrder.articleCollection) {
                getBudgetsForCompany(vm.purchaseOrder.company);
                recalculateBudgetData();
            }
        });

        $scope.$watch(function() { return vm.purchaseOrder.articleCollection.id; }, function() {
            if (vm.purchaseOrder.company && vm.purchaseOrder.articleCollection) {
                getBudgetsForCompany(vm.purchaseOrder.company);
                recalculateBudgetData();
            }
        });
    }

    function onChanges() {
    }

    function onDestroy() {
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    function captureOtbGrid(s) {
        otbGrid = s;
        otbGrid.itemsSource = rowCollection;
    }

    function getBudgetsForCompany(company) {
        if (company.id) {
            BudgetsApiService.getBudgetsForCompany(company.id).then(function(response) {
                rowData.length = 0;

                vm.companyBudgets = response.data;

                var collectionFiltered = _.filter(vm.companyBudgets, function(budget) {
                    return budget.collection.id === vm.purchaseOrder.articleCollection.id;
                });

                var locationGrouped = _.groupBy(collectionFiltered, function(budget) {
                    return budget.location.id;
                });

                _.forEach(Object.keys(locationGrouped), function(key) {
                    var group = locationGrouped[key];
                    var groupLocation = group[0].location;

                    var element = {
                        location: groupLocation,
                        totalOrderedQuantity: _.sumBy(group, function(obj) { return obj.orderedQuantity; }),
                        totalOrderedCost: Math.round(_.sumBy(group, function(obj) { return obj.orderedCost; })),
                        costPriceThisOrder: 0,
                        quantityThisOrder: 0,
                        totalQuantity: 0,
                        totalCost: 0,
                        budgetQuantity: _.sumBy(group, function(obj) { return obj.quantity; }),
                        budgetCost: _.sumBy(group, function(obj) { return obj.purchaseCost; }),
                        openToBuyQuantity: 0,
                        openToBuyCost: 0,
                        openToBuyPercentage: 0
                    };

                    // Totals
                    element.totalQuantity = element.totalOrderedQuantity + element.quantityThisOrder;
                    element.totalCost = Math.round(element.totalOrderedCost + element.costPriceThisOrder);

                    // Open to buy values
                    element.openToBuyQuantity = element.budgetQuantity - element.totalQuantity;
                    element.openToBuyCost = Math.round(element.budgetCost - element.totalCost);
                    element.openToBuyPercentage = Math.round(element.openToBuyCost / element.budgetCost * 100);

                    rowData.push(element);
                });

                var totalsElement = {
                    totalOrderedQuantity: 0,
                    totalOrderedCost: 0,
                    costPriceThisOrder: 0,
                    quantityThisOrder: 0,
                    totalQuantity: 0,
                    totalCost: 0,
                    budgetQuantity: 0,
                    budgetCost: 0,
                    openToBuyQuantity: 0,
                    openToBuyCost: 0,
                    isTotalsRowElement: true
                };

                rowData.push(totalsElement);

                var isNewPurchaseOrder = vm.purchaseOrder.id === undefined || vm.purchaseOrder.id === 0;

                if (!isNewPurchaseOrder) {
                    recalculateBudgetData();
                    _.forEach(rowData, function(row) {
                        row.totalOrderedQuantity -= row.quantityThisOrder;
                        row.totalOrderedCost -= row.costPriceThisOrder;
                    });
                }

                if (otbGrid.invalidate) {
                    otbGrid.invalidate();
                    rowCollection.refresh();
                }

            }, function(error) {
                ToasterService.showError(error.message);
            });
        }
    }

    function recalculateBudgetData() {
        var locations = [];
        _.forEach(rowData, function(row) {
            if (row.location) {
                locations.push(row.location);
            }
        });

        _.forEach(rowData, function(row) {
            row.quantityThisOrder = 0;
            row.costPriceThisOrder = 0;
        });

        var totalsRow = _.find(rowData, function(row) {
            return row.isTotalsRowElement;
        });

        if (totalsRow === undefined) {
            return;
        }

        totalsRow.totalOrderedQuantity = 0;
        totalsRow.totalOrderedCost = 0;
        totalsRow.costPriceThisOrder = 0;
        totalsRow.quantityThisOrder = 0;
        totalsRow.totalQuantity = 0;
        totalsRow.totalCost = 0;
        totalsRow.budgetQuantity = 0;
        totalsRow.budgetCost = 0;
        totalsRow.openToBuyQuantity = 0;
        totalsRow.openToBuyCost = 0;

        _.forEach(vm.purchaseOrder.orders, function(order) {
            var currentLocation = order.destination;
            var budgetRow = _.find(rowData, function(row) {
                if (row.location === undefined) {
                    return false;
                }
                return row.location.id === currentLocation.id;
            });

            if (budgetRow) {
                _.forEach(order.orderArticles, function(orderArticle) {
                    _.forEach(orderArticle.orderRows, function(orderRow) {
                        budgetRow.quantityThisOrder += orderRow.quantity;
                        budgetRow.costPriceThisOrder += orderRow.quantity * orderRow.purchaseCost;
                    });
                });

                budgetRow.totalQuantity = budgetRow.quantityThisOrder + budgetRow.totalOrderedQuantity;
                budgetRow.totalCost = budgetRow.totalOrderedCost + budgetRow.costPriceThisOrder;
                budgetRow.openToBuyQuantity = budgetRow.budgetQuantity - budgetRow.totalQuantity;
                budgetRow.openToBuyCost = Math.round(budgetRow.budgetCost - budgetRow.totalCost);
                budgetRow.openToBuyPercentage = Math.round(budgetRow.openToBuyCost / budgetRow.budgetCost * 100);
            }
        });

        var budgetRows = _.reject(rowData, function(row) {
            return row.isTotalsRowElement;
        });

        _.forEach(budgetRows, function(row) {
            totalsRow.totalOrderedQuantity += row.totalOrderedQuantity;
            totalsRow.totalOrderedCost += row.totalOrderedCost;
            totalsRow.costPriceThisOrder += row.costPriceThisOrder;
            totalsRow.quantityThisOrder += row.quantityThisOrder;
            totalsRow.totalQuantity += row.totalQuantity;
            totalsRow.totalCost += row.totalCost;
            totalsRow.budgetQuantity += row.budgetQuantity;
            totalsRow.budgetCost += row.budgetCost;
            totalsRow.openToBuyQuantity += row.openToBuyQuantity;
            totalsRow.openToBuyCost += row.openToBuyCost;
        });

        totalsRow.openToBuyPercentage = Math.round(totalsRow.openToBuyCost / totalsRow.budgetCost * 100);

        if (otbGrid.invalidate) {
            otbGrid.invalidate();
            rowCollection.refresh();
        }
    }
}
